import script from "./PreviewImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewImage.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewImage.vue?vue&type=style&index=0&id=0ce69212&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce69212"]])

export default __exports__